// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-header-section{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.device-pagination{
    margin-bottom: 30px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/devices/devices.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".sub-header-section{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n.device-pagination{\n    margin-bottom: 30px;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
